import React from "react";
import {
  getHarvestStyle,
  getPublicSymbolSize,
  getAdjustedFontSize,
  getFontFamily,
} from "../Common/StylesHelper";
import PublicPreviewPriceDisplay from "components/common/PublicPreviewPriceDisplay";
import PublicTagShape from "./PublicTagShape";
import DragScroll from "components/common/DragScroll";

const HarvestGrid = ({
  products = [],
  config,
  styles,
  primaryColor,
  theme = {},
  layoutSettings,
  language,
  currencyInfo,
}) => {
  const { width, height } = getPublicSymbolSize(styles?.productPrice?.size);

  const { itemSpacing, cardStyle } = layoutSettings?.productGrid || {};

  const {
    showPrice,
    showTitle,
    showVariety,
    showProcess,
    showCountry,
    showFlavour,
    showTags,
    showCategory,
    showAltitude,
  } = config || {};

  const {
    backgroundColor,
    borderColor,
    borderWidth,
    borderRadius,
    backgroundOpacity,
  } = cardStyle || {};

  const cardStyles = {
    backgroundColor: hexToRgba(backgroundColor, backgroundOpacity),
    marginTop: "10px",
    // marginTop: Math.max(itemSpacing ?? 0, 30),
    border: `${borderWidth}px solid ${borderColor}`,
    borderRadius: borderRadius || "25px",
  };

  const innerItemStyle = {
    border: `${borderWidth}px solid ${borderColor}`,
    borderRadius: borderRadius,
  };
  const { color } = { ...getHarvestStyle(styles, "productTitle", language) };
  function hexToRgba(hex, opacity) {
    const r = parseInt(hex?.slice(1, 3), 16);
    const g = parseInt(hex?.slice(3, 5), 16);
    const b = parseInt(hex?.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }
  return (
    <div className="product_list">
      {products?.length > 0 &&
        products.map((product, index) => (
          <div
            className="product_list_wrapper"
            key={product.productId || index}
            style={cardStyles}
          >
            {/* --- Conditionally render Country & Price if in listOrder --- */}
            {showTags && (
              <div className="d-flex justify-content-end">
                <PublicTagShape
                  shape={product?.tags?.id}
                  color={product?.tags?.color || "#A47E51"}
                  name={product?.tags?.label}
                  styles={styles}
                  width={60}
                  height={60}
                  wrapperClass="common_shape_tag harvest_grid"
                />
              </div>
            )}
            <div className="g_between">
              <div
                className="d-flex align-items-center gap-2"
                style={{ visibility: showCountry ? "visible" : "hidden" }}
              >
                {product?.countryCode && (
                  <img
                    src={`https://flagcdn.com/w40/${product?.countryCode?.toLowerCase()}.png`}
                    width={23}
                    height={15}
                  />
                )}
                <h5
                  style={{
                    ...getHarvestStyle(styles, "countryName", language),
                    color: styles["productTitle"].color || "#A47E51",
                    fontSize: getAdjustedFontSize(
                      12,
                      getFontFamily(styles, "countryName", language)
                    ),
                  }}
                  className="in_2_line mt-1"
                >
                  {language === "en"
                    ? product?.countryName
                    : product?.arabic?.countryName || product?.countryName}
                </h5>
              </div>
            </div>

            <div className="inner_section">
              {/* Title - Full width */}
              {showTitle && (
                <div className="d-flex gap-1 align-items-center">
                  {/* <p style={{ ...getHarvestStyle(styles, "productTitle", language) }}>
                    {language === "en" ? "Title" : "عنوان"}:
                  </p> */}
                  <p
                    style={{
                      ...getHarvestStyle(styles, "productTitle", language),
                      fontSize: getAdjustedFontSize(
                        20,
                        getFontFamily(styles, "productTitle", language)
                      ),
                    }}
                  >
                    {language === "en"
                      ? product?.productTitle
                      : product?.arabic?.productTitle || product?.productTitle}
                  </p>
                </div>
              )}

              {(showVariety || showProcess || showAltitude) && (
                <div
                  className="d-flex gap-2 details_wrapper"
                  style={{ width: "100%" }}
                >
                  {showVariety &&
                    (
                      product?.productVariety ||
                      product?.arabic?.productVariety ||
                      ""
                    ).trim() && (
                      <div
                        className={`single_detail_wrapper ${
                          // Check if Variety is shown on the left
                          showProcess &&
                          (
                            product?.productProcess ||
                            product?.arabic?.productProcess ||
                            ""
                          ).trim() &&
                          // Check if Altitude is shown on the right
                          showAltitude &&
                          (
                            product?.altitude ||
                            product?.arabic?.altitude ||
                            ""
                          ).trim()
                            ? "single_present"
                            : ""
                        }`}
                        style={{ flex: "1", minWidth: 0 }}
                      >
                        <p
                          className={`product_detail_para_title`}
                          style={{
                            ...getHarvestStyle(
                              styles,
                              "productVariety",
                              language,
                            ),
                          }}
                        >
                          {language === "en" ? "Variety" : "السلالة"}
                        </p>
                        <p
                          style={{
                            ...getHarvestStyle(
                              styles,
                              "productVariety",
                              language,
                            ),
                            fontSize: getAdjustedFontSize(
                              12,
                              getFontFamily(styles, "productVariety", language)
                            ),
                          }}
                        >
                          {language === "en"
                            ? product?.productVariety
                            : product?.arabic?.productVariety ||
                              product?.productVariety ||
                              ""}
                        </p>
                      </div>
                    )}

                  {showProcess &&
                    (
                      product?.productProcess ||
                      product?.arabic?.productProcess ||
                      ""
                    ).trim() && (
                      <div
                        className={`single_detail_wrapper ${
                          // Check if Variety is shown on the left
                          showVariety &&
                          (
                            product?.productVariety ||
                            product?.arabic?.productVariety ||
                            ""
                          ).trim() &&
                          // Check if Altitude is shown on the right
                          showAltitude &&
                          (
                            product?.altitude ||
                            product?.arabic?.altitude ||
                            ""
                          ).trim()
                            ? "border-x"
                            : "single_present"
                        }`}
                        style={{
                          flex: "1",
                          minWidth: "100px",
                          borderColor: hexToRgba(color, 0.2),
                        }}
                      >
                        <p
                          className={`product_detail_para_title`}
                          style={{
                            ...getHarvestStyle(
                              styles,
                              "productProcess",
                              language,
                            ),
                          }}
                        >
                          {language === "en" ? "Process" : "المعالجة"}
                        </p>
                        <p
                          style={{
                            ...getHarvestStyle(
                              styles,
                              "productProcess",
                              language,
                            ),
                            fontSize: getAdjustedFontSize(
                              12,
                              getFontFamily(styles, "productProcess", language)
                            ),
                          }}
                        >
                          {language === "en"
                            ? product?.productProcess
                            : product?.arabic?.productProcess ||
                              product?.productProcess ||
                              ""}
                        </p>
                      </div>
                    )}

                  {showAltitude &&
                    (
                      product?.altitude ||
                      product?.arabic?.altitude ||
                      ""
                    ).trim() && (
                      <div
                        className={`single_detail_wrapper ${
                          // Check if Variety is shown on the left
                          showProcess &&
                          (
                            product?.productProcess ||
                            product?.arabic?.productProcess ||
                            ""
                          ).trim() &&
                          // Check if Altitude is shown on the right
                          showVariety &&
                          (
                            product?.productVariety ||
                            product?.arabic?.productVariety ||
                            ""
                          ).trim()
                            ? "single_present"
                            : ""
                        }`}
                        style={{ flex: "1", minWidth: 0 }}
                      >
                        <p
                          className={`product_detail_para_title`}
                          style={{
                            ...getHarvestStyle(
                              styles,
                              "productProcess",
                              language,
                            ),
                            fontSize: getAdjustedFontSize(
                              12,
                              getFontFamily(styles, "productProcess", language)
                            ),
                          }}
                        >
                          {language === "en" ? "Altitude" : "الارتفاع"}
                        </p>
                        <p
                          style={{
                            ...getHarvestStyle(
                              styles,
                              "productProcess",
                              language,
                            ),
                            fontSize: getAdjustedFontSize(
                              12,
                              getFontFamily(styles, "productProcess", language)
                            ),
                          }}
                        >
                          {language === "en"
                            ? product?.altitude
                            : product?.arabic?.altitude ||
                              product?.altitude ||
                              ""}
                        </p>
                      </div>
                    )}
                </div>
              )}

              {showFlavour &&
                product?.productFlavour.trim() &&
                (
                  product?.productFlavour ||
                  product?.arabic?.productFlavour ||
                  ""
                ).trim() && (
                  <div className="flavor_wrapper">
                    <p
                      className={`product_detail_para_title`}
                      style={{
                        ...getHarvestStyle(styles, "productFlavour", language),
                      }}
                    >
                      {language === "en" ? "Flavour" : "الايحاءات"}
                    </p>
                    <p
                      style={{
                        ...getHarvestStyle(styles, "productFlavour", language),
                        fontSize: getAdjustedFontSize(
                          12,
                          getFontFamily(styles, "productFlavour", language)
                        ),
                      }}
                    >
                      {language === "en"
                        ? product?.productFlavour
                        : product?.arabic?.productFlavour ||
                          product?.productFlavour ||
                          ""}
                    </p>
                  </div>
                )}

              {/* Pricing Section - Show only if conditions are met */}
              {(() => {
                const priceAndSizes = [
                  ...(product?.addonsOptions?.priceAndSizes || []),
                  ...(product?.addonsOptions?.modifierOptions || []),
                ];
                const hasPriceAndSizes = priceAndSizes.length > 0;
                const hasProductPrice =
                  !hasPriceAndSizes && (product.productPrice ?? 0) > 0;
                const shouldShowPricing = hasPriceAndSizes || hasProductPrice;

                if (!shouldShowPricing || !showPrice) return null;

                return (
                  <div
                    className="pricing_section"
                    style={{
                      borderTopColor:
                        styles["productPrice"].color || primaryColor,
                    }}
                  >
                    <div className="g_between pricing_headings">
                      <span
                        className="pricing_heading"
                        style={{
                          ...getHarvestStyle(
                            styles,
                            "productFlavour",
                            language,
                          ),
                          fontSize: getAdjustedFontSize(
                            14,
                            getFontFamily(styles, "productFlavour", language)
                          ),
                        }}
                      >
                        {language === "en" ? "PRICING" : "التسعير"}
                      </span>
                      {hasPriceAndSizes && priceAndSizes.length > 2 && (
                          <span
                            style={{
                              ...getHarvestStyle(
                                styles,
                                "productFlavour",
                                language,
                              ),
                            }}
                          >
                            {language === "en"
                              ? "SWIPE FOR MORE"
                              : "اسحب للمزيد"}
                          </span>
                        )}
                    </div>

                    {/* Show multiple sizes if priceAndSizes exists */}
                    {hasPriceAndSizes ? (
                      <div
                        className="d-flex gap-2 addon_scroller"
                        style={{
                          WebkitOverflowScrolling: "touch",
                        }}
                      >
                        <DragScroll className="inner_section addon_sizes_dragger">
                          {priceAndSizes.map(
                            (size, idx) => (
                              <div
                                key={size.id || idx}
                                className="d-flex flex-column align-items-center addon_size_wrapper"
                                style={{
                                  flexShrink: 0,
                                  borderColor:
                                    styles["productPrice"].color ||
                                    primaryColor,
                                }}
                              >
                                <span
                                  style={{
                                    ...getHarvestStyle(
                                      styles,
                                      "productFlavour",
                                      language,
                                    ),
                                  }}
                                >
                                  {size.name}
                                </span>
                                <p
                                  className="product-price ltr w_fit_content addon_size"
                                  style={{
                                    ...getHarvestStyle(
                                      styles,
                                      "productPrice",
                                      language,
                                    ),
                                    margin: 0,
                                  }}
                                >
                                  <PublicPreviewPriceDisplay
                                    currencyInfo={currencyInfo}
                                    productPrice={size.price ?? "0"}
                                    width={10}
                                    height={10}
                                    primaryColor={
                                      styles["productPrice"].color ||
                                      primaryColor
                                    }
                                    extraSpanStyles={{
                                      fontSize: getAdjustedFontSize(
                                        12,
                                        getFontFamily(styles, "productPrice", language)
                                      ),
                                    }}
                                  />
                                </p>
                              </div>
                            ),
                          )}
                        </DragScroll>
                      </div>
                    ) : (
                      /* Show single product price if no priceAndSizes */
                      <p
                        className="product-price ltr w_fit_content only_pricing_harvest"
                        style={{
                          ...getHarvestStyle(styles, "productPrice", language),
                          fontSize: getAdjustedFontSize(
                            12,
                            getFontFamily(styles, "productPrice", language)
                          ),
                        }}
                      >
                        <div className="d-flex justify-content-center">
                          <PublicPreviewPriceDisplay
                            currencyInfo={currencyInfo}
                            productPrice={product.productPrice ?? "0"}
                            width={12}
                            height={12}
                            primaryColor={
                              styles["productPrice"].color || primaryColor
                            }
                            extraSpanStyles={{
                              fontSize: getAdjustedFontSize(
                                14,
                                getFontFamily(styles, "productPrice", language)
                              ),
                            }}
                          />
                        </div>
                      </p>
                    )}
                  </div>
                );
              })()}
            </div>
          </div>
        ))}
    </div>
  );
};

export default HarvestGrid;
